<div id="fachgebiete" class="page-wrapper">

	<app-menu [activeMenuIndex]="6">
	</app-menu>

	<!--<div class="subheader-bar-wrapper">
		<div class="subheader-content">
			<a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
				<div class="subheader-content-text">
					Ihr kostenfreies Testset!
				</div>
			</a>
		</div>
	</div>-->

	<div class="title-wrapper">
    <div class="m-t-30 img-header">
      <img src="/assets/img/template/03-nephrologie/nephro-header.png" />
    </div>
		<h1>
			Nephrologie
		</h1>
    <h2>
      Wann sollte in der
      Nephrologie an das
      Vorliegen eines Morbus
      Fabry gedacht werden?
    </h2>
    <p>Bei nicht anderweitig erklärten Befunden; dazu gehören:</p>
		<div class="title-description">
      <ul class="bullet-nephrologie">
        <li>Albuminurie, Proteinurie</li>
        <li>Progrediente Einschränkung der Nierenfunktion</li>
        <li>Verminderte Kreatinin-Clearance</li>
        <li>Polyurie, Polydipsie</li>
        <li>Glomerulosklerose</li>
        <li>Häufige Nierenzysten</li>
        <li>Terminale Niereninsuffizienz, Nierenersatztherapie</li>
      </ul>
		</div>
	</div>

	<div class="info-section fullwidth info-ribbon color-white bgcolor-nephrologie">
    <p class="info-section-subtitle2 text-center">
      <strong>20–30 % aller nephrologischen
      Patienten haben eine nicht<br>
      zufriedenstellende Diagnose!<sup class="info-section-text-ref">1</sup></strong>
		</p>
    <div class="ribbon-center"><img src="/assets/img/template/03-nephrologie/dreieck-2.png"></div>
	</div>

  <div class="m-t-50 m-b-50"></div>

  <div class="info-section fullwidth info-ribbon with-video-float color-nephrologie bgcolor-nephrologie-inverted">
    <div class="ribbon-left"><img src="/assets/img/template/03-nephrologie/dreieck-1.png"></div>
    <div class="info-section-title">
			Wann sollte in der Nephrologie an Morbus Fabry gedacht werden?
		</div>
    <p class="text-center">
      Dies erläutert Dr. Fabian Braun, Hamburg, im Nephrologie-Expertenvideo.
		</p>
    <div class="video-float">
      <iframe src="https://www.youtube.com/embed/qwX_U0wNsAU" class="nephrologie" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
	</div>

  <div class="info-section m-b-20">
    <div class="wrapper-half-center">
      <div class="separator m-t-0 nephrologie"></div>
      <div class="info-section-title">
        Morbus Fabry ist eine Multisystemerkrankung
      </div>
      <p class="text-center">
        Da es sich um eine Multisystemerkrankung
        handelt, sollten neben den
        o. g. nephrologischen Befunden zur
        Erhärtung des Verdachts andere
        Organsysteme in die Beurteilung miteinbezogen
        werden. So sollte vor allem
        bei folgenden <strong>Organmanifestationen</strong>
        an das Vorliegen eines Morbus Fabry
        gedacht und darauf getestet werden:
      </p>
    </div>
    <div class="wrapper-half-center">
      <div class="cols-3 p-t-20 bgcolor-white color-black">
        <div class="col m-b-10">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/03-nephrologie/herz-icon.png" />
          </div>
          <p class="text-center m-t-0">
            Unklare linksventrikuläre Hypertrophie
          </p>
        </div>
        <div class="col m-b-10">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/03-nephrologie/gehirn-icon.png" />
          </div>
          <p class="text-center m-t-0">
            Stattgehabter Apoplex bei jungen Menschen
          </p>
        </div>
        <div class="col m-b-10">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/03-nephrologie/haut-icon.png" />
          </div>
          <p class="text-center m-t-0">Angiokeratome, die als<br>
            kleine rötliche<br>
            Gefäßerweiterungen
            <br>stammnah lokalisiert sind<br>
            (diagnostisch hinweisend,<br>
            jedoch nicht beweisend)
          </p>
        </div>
        <div class="col m-b-10">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/03-nephrologie/neuro-icon.png" />
          </div>
           <p class="text-center m-t-0">Brennende Schmerzen an<br>
            den distalen Extremitäten</p>
        </div>
        <div class="col m-b-10">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/03-nephrologie/darm-icon.png" />
          </div>
          <p class="text-center m-t-0">Gastrointestinale<br>
            Beschwerden</p>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-0">
    <div class="wrapper-half-title-center">
      <div class="separator nephrologie"></div>
        <div class="info-section-title">
          Die Nierenbeteiligung ist eine der<br>
          bedeutendsten Organbeteiligungen bei<br>
          Morbus Fabry.<sup class="info-section-text-ref">2</sup>
        </div>
      </div>
    <div class="wrapper-center">
        <div class="cols-2 p-t-20">
          <div class="col">
            <div class="info-section-image m-b-0">
              <img src="/assets/img/template/03-nephrologie/frau-icon.png" />
            </div>
            <p class="text-center m-t-0 m-b-40">ca. 40 % der weiblichen<br>Fabry-Patienten<sup class="info-section-text-ref">3</sup></p>
            <div class="info-section-image m-b-0">
              <img src="/assets/img/template/03-nephrologie/mann-icon.png" />
            </div>
            <p class="text-center m-t-0 m-b-40">ca. 60 % der männlichen<br>Fabry-Patienten<sup class="info-section-text-ref">3</sup></p>
            <div class="info-section-image m-b-0">
              <img src="/assets/img/template/03-nephrologie/nieren-icon.png" />
            </div>
            <p class="text-center m-t-0">Renale Symptome können in jeder<br>
              Lebensdekade auftreten</p>
            <p class="text-center m-t-0 m-b-40">Pathologische Veränderungen durch<br>
              <a href="morbus-fabry#section-2" class="color-nephrologie"><strong>Gb3-Akkumulation</strong></a> in allen Zelltypen<br>
              der Niere nachweisbar<sup class="info-section-text-ref">4</sup></p>
          </div>
          <div class="col">
            <div class="info-section-block m-t-30">
              <div class="info-section-circle-center nephrologie m-b-40">
                <div>
                  <div class="subtitle">
                  Je früher eine <a href="therapie-login" class="color-white">Therapie</a><br>
                  begonnen wird,<br>
                  <strong>desto eher kann ein<br>
                    Funktionsverlust der<br>
                    Nieren verhindert oder<br>
                    zumindest verlangsamt<br>
                    werden!</strong>
                  </div>
                </div>
              </div>
              <div class="info-section-circle-center-badge nephrologie">
                <div>
                  Wichtig!
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-20">
    <div class="wrapper-half-title-center">
      <div class="separator nephrologie"></div>
      <div class="info-section-title m-t-20">
        Bei jedem zweiten Fabry-Patienten sind die Nieren maßgeblich beteiligt<sup class="info-section-text-ref">5,6</sup>
      </div>
    </div>
    <div class="wrapper-half-center">
      <div class="info-section-subtitle3 color-nephrologie text-center">Alter der Fabry-Patienten beim Einsetzen der Symptome</div>
      <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/03-nephrologie/alter-chart@2x.png" />
      </div>
      <div class="text-em margin-center text-center">
        Abb. modifiziert nach CYBULLLA, M. et al. 2007<sup class="info-section-text-ref">5</sup>
      </div>
    </div>
  </div>

  <div class="info-section m-t-30">
    <div class="info-section-block">
			<div class="info-section-circle-center nephrologie">
				<div>
					<strong>Unklare Proteinurie im<br>
            frühen Erwachsenenalter<br>
            kann ein wichtiger Hinweis<br>
            auf Morbus Fabry sein.
          </strong>
				</div>
			</div>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-20">
    <div class="wrapper-half-title-center">
      <div class="separator nephrologie"></div>
      <div class="info-section-title">
        Prävalenz von Morbus Fabry bei<br>Menschen mit Niereninsuffizienz
      </div>
    </div>
    <div class="wrapper-half-center">
        <ul class="bullet-nephrologie text-center">
        <li>Bei Patienten mit terminaler Niereninsuffizienz: 0,2–1,2 %<sup class="info-section-text-ref">7–10</sup></li>
        <li>Bei männlichen Nierentransplantierten: 0,36–0,37 %<sup class="info-section-text-ref">11</sup></li>
      </ul>
    </div>
    <div class="wrapper-center m-t-40">
      <div class="info-section-subtitle3 color-nephrologie text-center m-t-30 m-b-20">Dialysepflichtige Patienten</div>
      <div class="info-section-image text-center">
        <img src="/assets/img/template/03-nephrologie/dialysepflichtige-chart.png" />
      </div>
      <div class="cols-2 m-t-30">
        <div class="col">
          <div class="info-section-subtitle3 color-nephrologie text-center m-b-20">Patienten mit<br>Nierenersatztherapie*</div>
          <div class="info-section-image text-center">
            <img src="/assets/img/template/03-nephrologie/nierenersatztherapie-chart.png" />
          </div>
        </div>
        <div class="col m-t-30">
          <div class="info-section-subtitle3 color-nephrologie text-center m-b-20">Patienten mit<br>unklarer CKD, Stadium 1–5</div>
          <div class="info-section-image text-center">
            <img src="/assets/img/template/03-nephrologie/patienten-chart.png" />
          </div>
        </div>
      </div>
      <div class="text-em margin-center text-center">
        CKD: Chronic Kidney Disease. * Dialyse oder Transplantation; # 0,99 % der männlichen Dialysepatienten zwischen 30 und 39 Jahren und 1,33 %<br>
        der männlichen Dialysepatienten zwischen 40 und 49 Jahren; $ außerdem 19 Patienten mit VUS D313Y (VUS: Variant of uncertain significance).
      </div>
      <div class="info-section-image text-center m-t-50 m-b-50">
        <img src="/assets/img/template/03-nephrologie/achtung-orange.png" />
      </div>
    </div>
    <div class="wrapper-half-center">
        <p class="text-center">Insbesondere bei Männern mit klassischem Phänotyp führt die Nierenerkrankung
        unbehandelt zu <strong>progredientem GFR-Verlust</strong> (chronische Nierenerkrankung – CKD) bis hin zu
        terminaler Niereninsuffizienz mit Dialysebehandlung oder Nierentransplantation.<sup class="info-section-text-ref">4</sup></p>
      <div class="info-section-subtitle3 color-nephrologie text-center m-t-40 m-b-20">Progrediente Niereninsuffizienz: eGFR-Verlauf ohne Therapie<sup class="info-section-text-ref">15</sup></div>
      <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/03-nephrologie/progrediente-chart.png" />
      </div>
      <div class="text-em margin-center text-center">
        Abb. modifiziert nach WEST, M. et al. 2009<sup class="info-section-text-ref">15</sup>
      </div>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-20">
    <div class="wrapper-half-title-center m-b-30">
      <div class="separator nephrologie"></div>
      <div class="info-section-title">
        Fortschreitenden Verlust der<br>
        Nierenfunktion bei Morbus Fabry-Patienten
        frühzeitig stoppen!
      </div>
    </div>
    <div class="wrapper-half-center">
      <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/03-nephrologie/fortschreitenden-chart@2x.png" />
      </div>
      <div class="text-em margin-center text-center m-b-30">
        eGFR: geschätzte glomeruläre Filtrationsrate; ESRD: End Stage Renal Disease.<br>
        Abb. modifiziert nach SCHIFFMANN, R. et al. 2009<sup class="info-section-text-ref">16</sup>
      </div>
      <p class="text-center">
        Je größer die Vorschädigung der Niere, umso rascher die Progression.
      </p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-20">
    <div class="wrapper-half-center">
      <div class="separator nephrologie"></div>
      <div class="info-section-title">
        Proteinurie ist ein unabhängiger
        Risikofaktor hinsichtlich des Ausmaßes des
        Nierenfunktionsverlusts<sup class="info-section-text-ref">17</sup>
      </div>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-0">
    <div class="info-section-table margin-center m-b-40">
      <div class="title-nephrologie bgcolor-nephrologie text-center color-white">
        <strong>Unklare Albuminurie/Proteinurie<br>
          > 30 mg/g Kreatinin
        </strong><br>
        (mind. zwei Tests Spontanurin innerhalb von 3 Monaten)
      </div>
      <div class="info nephrologie">
        <div class="text-center color-nephrologie">
          <strong>Fragen Sie Ihren Patienten:</strong>
        </div>
        <ul class="bullet-nephrologie text-center">
          <li>Häufiges Pausieren im Sportunterricht?</li>
          <li>Positive Familienanamnese?</li>
          <li>Brennende Schmerzen in Händen/Füßen?</li>
          <li>Vermindertes Schwitzen?</li>
          <li>Magen-Darm-Beschwerden?</li>
          <li>Kleine rote Flecken auf der Haut?</li>
          <li>Schlaganfall/TIA?</li>
          <li>Luftnot? Verdickte Herzwand?</li>
        </ul>
      </div>
      <div class="title-nephrologie bgcolor-nephrologie text-center color-white">
        Mindestens eine Frage mit <div class="circle color-nephrologie">JA</div> <br>
        beantwortet?
      </div>
      <div class="info nephrologie">
        <div class="text-center">
          Ausschluss: Nephritiden u./o. bereits<br>
          <strong>bekannte Ursache</strong> der Proteinurie<br>
          (z. B. schlecht eingestellter Diabetes<br>
          mellitus oder lang vorbestehende<br>
          Hypertonie über angestrebtem Zielwert)<br>
          <br>
          <div class="info-section-subtitle3 color-nephrologie m-b-40">Verdacht auf Morbus Fabry?</div>
          <a href="https://www.lsd-diagnostik-partner.de" target="_blank" class="info-section-button color-nephrologie info-section-button-2">
            <strong>Testen Sie jetzt! →</strong>
          </a>
          <br>
          <br>
        </div>
      </div>
    </div>
    <div class="wrapper-half-center">
      <ul class="text-center bullet-nephrologie">
        <li>Proteinurie sollte spezifisch behandelt werden (ACE-Hemmer/AT1-Blocker).</li><br>
        <li>Proteinurie kann auch erst im Laufe der Erkrankung auftreten, selbst wenn die Niere bereits
          Gb3-Ablagerungen aufweist.</li><br>
      </ul>
      <div class="info-section-subtitle3 color-nephrologie text-center">Einfluss der Proteinurie auf die Verringerung der GFR<sup class="info-section-text-ref">16</sup>*</div>
      <div class="info-section-image text-center m-t-20 m-b-0">
        <img src="/assets/img/template/03-nephrologie/einfluss-chart@2x.png" />
      </div>
      <div class="text-em margin-center text-center">
        * Retrospektiv erhobene Daten. eGFR: geschätzte glomeruläre Filtrationsrate; SEM: Standardfehler des Mittelwertes;
        Gb3: Globotriaosylceramid.
        Abb. modifiziert nach SCHIFFMANN, R. et al. 2009<sup class="info-section-text-ref">16</sup>
      </div>
      <p class="text-center">Mikroalbuminurie ist ein erstes Anzeichen für eine Verschlechterung der Nierenfunktion.<sup class="info-section-text-ref">18</sup></p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-0">
    <div class="wrapper-half-center">
      <div class="separator nephrologie"></div>
      <div class="info-section-title m-t-20">
        Parapelvine Zysten treten bei 29,8–50 %
        der Morbus Fabry-Patienten mit
        Nierenbeteiligung auf<sup class="info-section-text-ref">19</sup>
      </div>
    </div>
    <div class="wrapper-center">
      <div class="cols-2 p-t-10">
        <div class="col">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/03-nephrologie/stethoskope-icon.png" />
          </div>
          <p class="text-center m-t-0">Gerade bei Patienten mit unklarer<br>
            Familienanamnese liefern parapelvine<br>
            Zysten einen diagnostischen Hinweis auf<br>
            Morbus Fabry.<sup class="info-section-text-ref">19,20</sup></p>
        </div>
        <div class="col">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/03-nephrologie/parapelvine-icon.png" />
          </div>
          <p class="text-center m-t-0">Parapelvine Zysten treten bei Fabry-<br>
            Patienten früher und häufiger auf als in<br>
            der Allgemeinbevölkerung.</p>
        </div>
      </div>
      <div class="wrapper-half-center m-t-30">
        <div class="info-section-subtitle3 color-nephrologie text-center">Anteil der Morbus Fabry-Patienten mit Nierenzysten nach Alter und Geschlecht</div>
        <div class="info-section-image text-center m-b-0">
          <img src="/assets/img/template/03-nephrologie/anteil-chart.png" />
        </div>
        <div class="text-em margin-center text-center">
          Abb. modifiziert nach PISANI, A. et al. 2018<sup class="info-section-text-ref">19</sup>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section">
    <div class="wrapper-half-title-center">
      <div class="separator m-t-30 nephrologie"></div>
      <div class="info-section-title">
        Histologische Hinweise auf Morbus Fabry
      </div>
    </div>
    <div class="wrapper-half-center m-t-40">
      <div class="info-section-subtitle3 color-nephrologie text-center">Histologisches Bild glomerulärer Schädigung<sup class="info-section-text-ref">21</sup></div>
      <div class="info-section-image text-center p-t-10">
        <img src="/assets/img/template/03-nephrologie/histologisches-chart.png" />
      </div>
    </div>
    <div class="wrapper-half-center">
      <div class="badge2">
        <div class="number nephrologie">1</div>
        <div class="text">Gb3-Ansammlung im glomerulären Epithel</div>
      </div>
      <br>
      <div class="badge2">
        <div class="number nephrologie">2</div>
        <div class="text">Distaler Tubulus</div>
      </div>
      <br>
      <div class="badge2">
        <div class="number nephrologie">3</div>
        <div class="text">Geringe Beteiligung des vaskulären Endothels</div>
      </div>
    </div>
    <div class="text-em margin-center text-center m-t-20">
      Abb. nach BRADEY, R.O. & SCHIFFMANN, R. 2000<sup class="info-section-text-ref">2</sup>, Toluidinblau-Färbung
    </div>
  </div>

  <div class="info-section p-b-40 fullwidth info-ribbon color-white bgcolor-nephrologie">
    <div class="ribbon-left-bottom"><img src="/assets/img/template/03-nephrologie/dreieck-2.png"></div>
    <div class="info-section-image text-center">
      <img src="/assets/img/template/03-nephrologie/arzt-icon.png" />
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">Eine Nierenbiopsie ist zur Bestätigung eines Verdachts auf Morbus Fabry nicht notwendig,
          kann jedoch sinnvoll sein, um zusätzliche Nierenerkrankungen zu diagnostizieren und eine
          Aussage über die <strong>renale Prognose</strong> zu bekommen. Die Pathologie sollte vorab über den
          Verdacht auf eine Speicherkrankheit informiert werden. Elektronen-mikroskopisch lassen sich
          bei der Fabry-Nephropathie <strong>multilamelläre Myelinkörper</strong> („Zebrakörperchen“) erkennen.
      </p>
      <div class="info-section-subtitle2 color-white text-center">
        <a href="https://www.lsd-diagnostik-partner.de/" target="_blank" style="text-decoration: underline;"><strong>Vor Nierentransplantation<br>auf Morbus Fabry testen!</strong></a>
      </div>
    </div>
	</div>
</div>

<div class="m-b-50"></div>

<app-footer>
</app-footer>

<style>
	/*.info-section-container {
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
		margin-bottom: 120px;
	}
	@media only screen and (max-width: 768px) {
		.info-section-container {
			width: calc(100% + 64px);
			margin-bottom: 8px;
		}
	}*/
</style>
